import { Switch } from '@advanza/advanza_generic'
import { LoadingDots } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import { useToast } from 'components/misc/Toaster'
import CentralizedReviewCollectionModal from 'components/providers/CentralizedReviewCollectionModal'
import { useCentralizedReviewCollection, useProvider } from 'hooks/providerHooks'

interface CentralizedReviewCollectionSettingsProps {
    providerId: number
}

const CentralizedReviewCollectionSettings = ({
    providerId,
}: CentralizedReviewCollectionSettingsProps) => {
    const { provider } = useProvider(providerId)
    const { setEnabled, isSaving } = useCentralizedReviewCollection(providerId)
    const { addToast } = useToast()

    const isEnabled = provider?.centralizedReviewCollection === true
    const nrFranchiseAccounts = provider?.nrFranchiseAccounts ?? 0

    const handleToggle = async () => {
        const enable = !isEnabled
        const confirmed = await NiceModal.show(CentralizedReviewCollectionModal, {
            enable,
            nrFranchiseAccounts,
        })

        if (confirmed !== true) {
            return
        }

        try {
            await setEnabled(enable)
            addToast({
                msg: enable
                    ? 'Reviews are now shared across the franchise'
                    : 'Reviews are no longer shared across the franchise',
                green: true,
                icon: 'check_circle',
            })
        } catch {
            addToast({
                msg: 'Could not change centralized review collection',
                red: true,
                icon: 'error',
            })
        }
    }

    return (
        <div className="grid grid-cols-[1fr_auto] gap-4 items-center">
            <div>
                <div className="font-bold">Centralized review collection</div>
                <div className="text-md text-grey-700">
                    Every review collected by any account of this franchise counts for all of them:
                    same review list, same number of reviews, same review score. Applies to the
                    whole franchise, not only this account.
                </div>
            </div>
            {isSaving ? (
                <LoadingDots />
            ) : (
                <Switch checked={isEnabled} onChange={handleToggle}></Switch>
            )}
        </div>
    )
}

export default CentralizedReviewCollectionSettings
